import { API_REQUEST } from ".";
import {
  contactUsAPI,
  homeSectionAPI,
  servicesAPI,
  servicesDetailByIdAPI,
  weightClassResrictioAPI,
} from "../../routes/apiEndPoints";
import { createAsyncThunk } from "@reduxjs/toolkit";

// fetch-dashboard-details
export const fetchDashboard = createAsyncThunk(
  "fetch-dashboard-details",
  async () => {
    try {
      const response = await API_REQUEST({
        url: homeSectionAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

// fetch-services
export const fetchServices = createAsyncThunk("fetch-services", async () => {
  try {
    const response = await API_REQUEST({
      url: servicesAPI,
      method: "GET",
    });
    return response;
  } catch (error) {}
});
// fetch-services-detaili-by-id
export const fetchServiceDetailById = createAsyncThunk(
  "fetch-services-detaili-by-id",
  async (props) => {
    const data = { id: props };
    try {
      const response = await API_REQUEST({
        url: servicesDetailByIdAPI,
        method: "GET",
        params: data,
      });
      return response;
    } catch (error) {}
  }
);

// contact-us
export const contactUs = createAsyncThunk("contact-us", async (props) => {
  const { payload, callback } = props;
  try {
    const response = await API_REQUEST({
      url: contactUsAPI,
      method: "POST",
      data: payload,
      isErrorToast: true,
    });
    callback(response);
    return response;
  } catch (error) {
    callback(null, error);
  }
});

// fetch-wieght-restrictions
export const fetchWeightRestriction = createAsyncThunk(
  "fetch-wieght-restrictions",
  async () => {
    try {
      const response = await API_REQUEST({
        url: weightClassResrictioAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);
